import {useState} from 'react';
import axios from 'axios';
const QuoteBoxLogic = (props) => {
    const [buttonHasBeenClicked,setButtonHasBeenClicked] = useState(false);
    
const postButtonWasClicked = () => {
      if(buttonHasBeenClicked === false){
      axios.post(`https://website-267617.uw.r.appspot.com/update_coder_log`, {
        "address" : props.address,
        "lat" : 41,
        "lon" : 41,
        "transfer" : 1,
        "distance" : 10
      })
      .then((res)=>{
        setButtonHasBeenClicked(true);
      })
      .catch((err) => console.log(err))}
    }


   return({postButtonWasClicked})
};

export default QuoteBoxLogic;